export const IS_SET_USER_ATTRIBUTE_STORAGE_KEY = 'IS_SET_USER_ATTRIBUTE'
